// frontend/smartdocs-admin/src/components/settings/QuerySettings.tsx
import React from 'react';
import { useSettings } from '@/context/SettingsContext';
import ToggleSwitch from '@shared/ToggleSwitch';
import SliderInput from '@shared/SliderInput';
import SettingsPage from "@/pages/SettingsPage";
import Card from "@shared/Card";

const QuerySettings: React.FC = () => {
  const { settings, updateSetting, loading } = useSettings();

  const querySettings = settings.Query || {};

  const handleUpdate = (key: string, value: any) => {
    updateSetting('Query', key, value);
  };

  return (
    <SettingsPage>
      <Card>
          <div className="space-y-6">
        {/*<h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Query and Search Settings</h2>*/}

        {/* Max Query Length */}
        <div>
          <label htmlFor="maxQueryLength" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Maximum Query Length</label>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">Sets the maximum number of characters allowed in a single search query.</p>
          <SliderInput
            id="maxQueryLength"
            label=""
            min={50}
            max={500}
            step={10}
            value={querySettings.maxQueryLength || 200}
            onChange={(value) => handleUpdate('maxQueryLength', value)}
            disabled={loading}
          />
        </div>

        {/* Query Timeout */}
        <div>
          <label htmlFor="queryTimeout" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Query Timeout (seconds)</label>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">The maximum time allowed for a query to execute before timing out.</p>
          <SliderInput
            id="queryTimeout"
            label=""
            min={5}
            max={60}
            step={5}
            value={querySettings.queryTimeout || 30}
            onChange={(value) => handleUpdate('queryTimeout', value)}
            disabled={loading}
          />
        </div>

        {/* Enable Fuzzy Search */}
        <div className="flex items-center justify-between">
          <div>
            <label htmlFor="fuzzySearch" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Enable Fuzzy Search</label>
            <p className="text-sm text-gray-500 dark:text-gray-400">Allow search queries to match terms that are similar, but not exact.</p>
          </div>
          <ToggleSwitch
            id="fuzzySearch"
            label=""
            checked={querySettings.fuzzySearch || false}
            onChange={(e) => handleUpdate('fuzzySearch', e.target.checked)}
            disabled={loading}
          />
        </div>

        {/* Enable Query Caching */}
        <div className="flex items-center justify-between">
          <div>
            <label htmlFor="queryCaching" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Enable Query Caching</label>
            <p className="text-sm text-gray-500 dark:text-gray-400">Store results of frequent queries to improve performance.</p>

          </div>
          <ToggleSwitch
            id="queryCaching"
            label=""
            checked={querySettings.queryCaching || false}
            onChange={(e) => handleUpdate('queryCaching', e.target.checked)}
            disabled={loading}
          />
        </div>

        {/* Default Search Language */}
        <div>
          <label htmlFor="defaultSearchLanguage" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Default Search Language</label>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">The default language for processing search queries.</p>
          <select
            id="defaultSearchLanguage"
            className="p-2 mt-1 block w-full h-12 rounded-md border-1 border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            value={querySettings.defaultSearchLanguage || 'en'}
            onChange={(e) => handleUpdate('defaultSearchLanguage', e.target.value)}
            disabled={loading}
          >
            <option value="en">English</option>
            <option value="es">Spanish</option>
            <option value="fr">French</option>
            <option value="de">German</option>
            <option value="zh">Chinese</option>
          </select>
        </div>
      </div>
      </Card>
    </SettingsPage>
  );
};

export default QuerySettings;
